import styled from 'styled-components';

export const SingInputStyled = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: nowrap;
  }
  .ant-form-item.no_label {
    margin-bottom: 0;
  }
  .no_label .ant-form-item-explain > div {
    font-size: 10px;
  }
  .ant-form-item-label {
    margin-right: 19px;
  }
  .ant-form-item-no-colon {
    width: ${(props) => props.labelwidth};
    height: ${(props) => props.height};
    display: flex;
    justify-content: center;
    background: ${(props) => props.theme[props.brand].formInput.singInputBg};
    /* color: ${(props) => props.theme[props.brand].formInput.color}; */
    font-size: 14px;
    border-radius: 0px;
  }
  .ant-input {
    min-width: ${(props) => props.inputWidth};
    max-width: ${(props) => props.maxWidth};
    height: ${(props) => props.height};
    background: ${(props) => props.theme[props.brand].formInput.inputBg};
    color: ${(props) =>
      props.theme[props.brand].formInput.inputContentColor} !important;
    font-size: 14px;
    border-radius: 0px;
    border-color: ${(props) => props.theme[props.brand].formInput.inputColor};
  }
  .ant-input-disabled {
    color: ${(props) => props.theme[props.brand].formInput.color};
    cursor: default;
  }
  .ant-input:hover,
  .ant-input-affix-wrapper:hover {
    border-color: ${(props) => props.theme[props.brand].formInput.singInputBg};
  }
  .ant-input:focus,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-color: ${(props) => props.theme[props.brand].formInput.singInputBg};
  }
  .ant-input-affix-wrapper {
    padding: 0;
    border: none;
    background: ${(props) => props.theme[props.brand].formInput.inputBg};
  }
  .ant-input-affix-wrapper > input.ant-input {
    padding-left: 10px;
  }
  .ant-input-suffix {
    margin: 0;
    position: relative;
    right: 12px;
  }
  .no_label {
    .ant-form-item-label {
      margin-right: 0;
    }
  }
  .dis-grey {
    .ant-input-disabled {
      color: #d9d9d9 !important;
      background-color: ${(props) =>
        props.theme[props.brand].formInput.inputBg} !important;
    }
  }
  .ant-form-item-explain {
    height: 0px;
    min-height: 0px;
  }
  .label-left .ant-form-item-no-colon {
    justify-content: left;
    padding-left: 13px;
  }
`;
